import { IOffer } from '../../repositories/search-offers/v2/types';
import { TBannerLocation } from '../../serp/components/demand/tracking';

export function getBannerLocation(
  offersLength: number,
  offersPerPage: number,
  suggestions: IOffer[] | null,
): TBannerLocation {
  const offersCountDiff = offersPerPage - offersLength;

  // Определяем, находимся ли мы выдаче с добивками
  const visibleSuggestions = suggestions && offersLength < offersPerPage ? suggestions.slice(0, offersCountDiff) : [];

  const isSuggestionsExists = visibleSuggestions.length > 0;
  // Устанавливаем для добивок свой лейбл banner_location в событии

  return isSuggestionsExists ? 'infinite' : 'after_pagination';
}
